
import { Map, Record } from 'immutable';
import { TaxListResponseModel } from '../tax-model/taxlist.response.model';
import { TaxNewResponse } from '../tax-model/taxnewResponse.model';

export interface TaxState extends Map<string, any> {
  taxList: Array<TaxListResponseModel>;
  taxListCount: any;
  taxNew: any;
  taxNewdetail: TaxNewResponse;
  taxupdate: any;
  taxDelete: any;

  listLoading: boolean;
  listLoaded: boolean;
  listFailed: boolean;

  countLoading: boolean;
  countLoaded: boolean;
  countFailed: boolean;

  addLoading: boolean;
  addLoaded: boolean;
  addFailed: boolean;

  updatLoading: boolean;
  updatLoaded: boolean;
  updatFailed: boolean;

  updateLoading: boolean;
  updateLoaded: boolean;
  updateFailed: boolean;

  deleteLoading: boolean;
  deleteLoaded: boolean;
  deleteFailed: boolean;
}

export const TaxRecordState = Record({
  taxList: {},
  taxListCount: {},
  taxNew: {},
  taxupdate: {},
  taxDelete: {},

  listLoading: false,
  listLoaded: false,
  listFailed: false,

  countLoading: false,
  countLoaded: false,
  countFailed: false,

  addLoading: false,
  addLoaded: false,
  addFailed: false,

  updatLoading: false,
  updatLoaded: false,
  updatFailed: false,

  updateLoading: false,
  updateLoaded: false,
  updateFailed: false,

  deleteLoading: false,
  deleteLoaded: false,
  deleteFailed: false
});
